export const services = {
  roles: process.env.REACT_APP_ROLES_SERVICE,
  users: process.env.REACT_APP_USERS_SERVICE,
  machineLearning: process.env.REACT_APP_MACHINE_LEARNING_SERVICE,
  auth: process.env.REACT_APP_AUTH_SERVICE,
  analytics: process.env.REACT_APP_ANALYTICS_SERVICE,
  'environment-variables': process.env.REACT_APP_ENVIRONMENT_SERVICE,
  institutions: process.env.REACT_APP_INSTITUTIONS_SERVICE,
  'chat-instances': process.env.REACT_APP_CHAT_INSTANCES_SERVICE,
  reactions: process.env.REACT_APP_REACTIONS_SERVICE,
  files: process.env.REACT_APP_FILES_SERVICE,
  procedures: process.env.REACT_APP_PROCEDURES_SERVICE,
  'comunication-channels': process.env.REACT_APP_COMUNICATION_CHANNELS_SERVICE,

  // ...otros servicios
};